// Copyright (c) 2020 Deere & Company

import './unitsPage.scss';
import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getUnits } from '../repositories';
import { setUnit } from '../../shared/action-creator/unit';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class UnitsPage extends Component {

    state = {
        units: []
    };

componentDidMount = () => {

    if ( this.props.location && this.props.location.state && this.props.location.state.error ) {

        setTimeout( () => this.props.createErrorMessage( this.props.location.state.error ) );

    }

    this.props.increaseCounter();
    getUnits().then( response => {

        this.setState( {
            units: response
        } );
        this.props.decreaseCounter();

    } ).catch( () => {

        this.props.decreaseCounter();

    } );

}

    handleUnitSelect = unit => {

        this.props.setUnit( unit );
        this.props.history.push( `/${unit.name}` );
        localStorage.setItem( 'selectedUnit', JSON.stringify( unit ) );

    }

    render () {

        const { units } = this.state;

        return (
            <section className="units-placeholder">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />

                <header>
                    <h2 className="page-header"> Select Unit </h2>
                </header>
                <main>
                    <div className="units-section">
                        <ul className="units-list">
                            {units.map( unit => (
                                <li key={unit.name} className="unit-link">
                                    <span onClick={() => this.handleUnitSelect( unit )}>
                                        {unit.description}({unit.name})
                                    </span>
                                </li>
                            ) )}
                        </ul>
                    </div>
                </main>
            </section>
        );

    }

}

UnitsPage.displayName = 'UnitsPage';
UnitsPage.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    createErrorMessage: PropTypes.func.isRequired,
    setUnit: PropTypes.func.isRequired,
    location: PropTypes.object,
    history: PropTypes.object
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter )
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
    setUnit: unit => dispatch( setUnit( unit ) )
} );
export default connect( mapStateToProps, mapDispatchToProps )( withRouter( UnitsPage ) );
